
import React, { Fragment } from 'react';

// Components

import ModalHeader from '../headers/ModalHeader';
import { FormattedMessage } from 'react-intl';
import { Button }from '@cmsgov/design-system';



const RequestErrorModal = props => {
    const {
        modalHeaderProps,
        actions: {
            hideModal
        },
        modal:{
            modalData: {
                message
            }
        },
        bottomAnchors: [
            anchor_1
        ],
        boundAnchor
    } = props;

    return (
        <Fragment>
            <div className = 'gi-modal__header__head'>
                <ModalHeader { ...{ ...modalHeaderProps }} />
            </div>
            <div className = 'gi-modal__body' id={`${modalHeaderProps.modalId}_body`}>
                <p>
                    <FormattedMessage id = 'modals.request_error.cannot_be_handled' values = { { message } }/>
                </p>
            </div>
            <div className = 'gi-modal__controls'>
                <Button
                    className = 'usa-button gi-button gi-button__primary'
                    onClick = { hideModal }
                    inputRef = { boundAnchor(anchor_1) }
                >
                    <FormattedMessage id = 'button.close'/>
                </Button>
            </div>
        </Fragment>
    );
};

export default RequestErrorModal;